import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaFacebookF, FaInstagram, FaYoutube, FaEnvelope, FaLinkedin } from 'react-icons/fa';
import './footer1.css';

const Footer1 = () => {
  return (
    <footer className="footer position-relative text-white py-5">
      <div className="footer-bg-pattern"></div>
      <Container>
        <Row>
          <Col md={10} className="mb-4">
            <h1 className="footer-quote">
              {/* <span className="quote-icon">“</span><br /> */}
              Empowering students
              with quality education<br />
              for a brighter future!
            </h1>
          </Col>
          <Col md={2}>
            <h6 className="footer-heading mt-4">Follow us</h6>
            <div className="footer-icons d-flex gap-3 mb-3">
              <a href="mailto:support@achieversiq.com"><FaEnvelope /></a>
              <a href="https://www.youtube.com/channel/UCVdgbUGrAQGUBVLDvlkv8iw"><FaYoutube /></a>
              <a href="https://www.instagram.com/achieversiq/?next=%2Fachievers_iq%2F"><FaInstagram /></a>
              <a href="https://www.facebook.com/profile.php?id=61575687207371"><FaFacebookF /></a>
              <a href="https://www.linkedin.com/company/107018327/admin/dashboard/"><FaLinkedin /></a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              <Col md={2} xs={6}>
                <h6 className="footer-heading">Classes</h6>
                <ul className="footer-list">
                  {['Class 6th','Class 7th','Class 8th','Class 9th','Class 10th','Class 11th','Class 12th'].map(cls => (
                    <li key={cls}><a href="#">{cls}</a></li>
                  ))}
                </ul>
              </Col>
              <Col md={2} xs={6}>
                <h6 className="footer-heading">Courses</h6>
                <ul className="footer-list">
                  {['AP','SAT','ACT','Boards','JEE Mains','JEE Advance','NEET Exams'].map(course => (
                    <li key={course}><a href="#">{course}</a></li>
                  ))}
                </ul>
              </Col>
              <Col md={3} xs={6}>
                <h6 className="footer-heading">Study Abroad</h6>
                <ul className="footer-list">
                  {['Bahrain','Kuwait','Oman','Qatar','USA','UK','Saudi Arabia','United Arab Emirates (UAE)'].map(place => (
                    <li key={place}><a href="#">{place}</a></li>
                  ))}
                </ul>
              </Col>
              <Col md={2} xs={6}>
                <h6 className="footer-heading">Address</h6>
                <p className="footer-address  text-warning-color">
                  Vazir Street, Dheera District<br />
                  Riyadh – 11371, K.S.A
                </p>
              </Col>
              <Col md={3}>
                <h6 className="footer-heading">Call us</h6>
                <p className="footer-phone text-warning-color">+966 566458463</p>
                <p><strong className='text-warning-color'>Monday - Saturday</strong></p>
                <h6 className="footer-heading">Chat to us</h6>
                <a href="mailto:support@webstudyz.com" className="footer-mail">support@achieversiq.com</a>
                <p className="footer-note">Mail us for admissions or any other queries.</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer1;
